import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useCloseModal } from '../../../components/modals/ModalsContext'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('listIntegrations')
  const onClose = useCloseModal()

  return (
    <>
      <Grid justify="space-between">
        <Col flex={1}>
          <Title size="h5" strong color="dark2" noMargin>
            {t('newIntegration')}
          </Title>

          <SmallText>{t('selectAccount')}</SmallText>
        </Col>
        <Col>
          <Icon name="BsX" onClick={onClose} size={1.5} color="dark3" />
        </Col>
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
